import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="menu"
export default class extends Controller {
  static targets = ['profileDropdown', 'mobileMenu', 'hamburger']

  connect () {
    // Close menu on window resize past md breakpoint (768px)
    this.handleResize = () => {
      if (window.innerWidth >= 768) {
        this.closeMobile()
      }
    }
    window.addEventListener('resize', this.handleResize)
  }

  disconnect () {
    window.removeEventListener('resize', this.handleResize)
  }

  toggleProfile () {
    this.profileDropdownTarget.classList.toggle('hidden')
  }

  closeMobile () {
    // Only close if menu is currently open
    if (!this.mobileMenuTarget.classList.contains('hidden')) {
      // Hide menu
      this.mobileMenuTarget.classList.add('hidden')

      // Restore body styling and scroll position
      this.unlockBodyScroll()

      // Reset hamburger animation
      if (this.hasHamburgerTarget && this.hamburgerTarget.classList.contains('x-state')) {
        const firstLine = this.hamburgerTarget.children[0]
        const secondLine = this.hamburgerTarget.children[1]

        firstLine.classList.remove('rotate-45', 'translate-y-0')
        secondLine.classList.remove('-rotate-45', '-translate-y-0.5')
        this.hamburgerTarget.classList.remove('space-y-0')
        this.hamburgerTarget.classList.add('space-y-1')
        this.hamburgerTarget.classList.remove('x-state')
      }
    }
  }

  toggleMobile () {
    this.mobileMenuTarget.classList.toggle('hidden')

    // Prevent body scrolling and lock scroll position when menu is open
    const isMenuOpen = !this.mobileMenuTarget.classList.contains('hidden')
    if (isMenuOpen) {
      // Save current scroll position
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop

      // Lock body in place and prevent scrolling
      document.body.style.position = 'fixed'
      document.body.style.top = `-${this.scrollPosition}px`
      document.body.style.width = '100%'
      document.body.style.overflow = 'hidden'
    } else {
      // Restore body styling and scroll position
      this.unlockBodyScroll()
    }

    // Toggle the rotation animation for hamburger lines to form an X
    if (this.hasHamburgerTarget) {
      const firstLine = this.hamburgerTarget.children[0]
      const secondLine = this.hamburgerTarget.children[1]

      // Toggle the X state
      this.hamburgerTarget.classList.toggle('x-state')

      if (this.hamburgerTarget.classList.contains('x-state')) {
        // Transform to X: rotate and position lines to intersect
        firstLine.classList.add('rotate-45', 'translate-y-0')
        secondLine.classList.add('-rotate-45', '-translate-y-0.5')
        // Remove the gap between lines
        this.hamburgerTarget.classList.remove('space-y-1')
        this.hamburgerTarget.classList.add('space-y-0')
      } else {
        // Reset to hamburger: remove rotations and restore spacing
        firstLine.classList.remove('rotate-45', 'translate-y-0')
        secondLine.classList.remove('-rotate-45', '-translate-y-0.5')
        this.hamburgerTarget.classList.remove('space-y-0')
        this.hamburgerTarget.classList.add('space-y-1')
      }
    }
  }

  unlockBodyScroll () {
    document.body.style.position = ''
    document.body.style.top = ''
    document.body.style.width = ''
    document.body.style.overflow = ''

    if (this.scrollPosition !== undefined) {
      window.scrollTo(0, this.scrollPosition)
    }
  }
}
